// X-0.B · Loader gateado de Plausible Analytics.
//
// O script de Plausible **non se inxecta no DOM ata que o usuario aceptou
// a categoría "analytics"** no banner de cookies. Iso garante que un
// visitante anónimo non tenga absolutamente ningunha cookie nin request a
// dominios de terceiros antes de dar consent (RGPD art. 6.1.a).
//
// Se aínda non está integrado Plausible (sen VITE_PLAUSIBLE_DOMAIN), a
// función é un no-op silencioso. Cando se configure no .env, o gancho xa
// está listo.

import { isCategoryEnabled } from "./cookieConsent";

let _plausibleInjected = false;

export function initAnalytics() {
  if (_plausibleInjected) return;
  if (typeof document === "undefined") return;
  if (!isCategoryEnabled("analytics")) return;

  const domain = import.meta.env.VITE_PLAUSIBLE_DOMAIN;
  const apiHost = import.meta.env.VITE_PLAUSIBLE_HOST || "https://plausible.io";
  if (!domain) return; // Sen config aínda; nada que cargar.

  const script = document.createElement("script");
  script.defer = true;
  script.dataset.domain = domain;
  if (import.meta.env.VITE_PLAUSIBLE_HOST) {
    script.dataset.apiHost = apiHost;
  }
  script.src = `${apiHost}/js/script.js`;
  document.head.appendChild(script);
  _plausibleInjected = true;
}

// Listener: se o usuario muda o consent durante a sesión, intentar cargar.
// Non hai forma de "descargar" Plausible se o desactiva — require recarga.
if (typeof window !== "undefined") {
  window.addEventListener("cookie-consent-changed", () => {
    initAnalytics();
  });
}
